class MFRWithDrag {
    constructor( index, element ) {
        this.$index = index;
        this.$element = $( element );

        this.init()
    }

    init() {
        let startX, startY;

        this.$element.bind( 'touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        } );
        this.$element.bind( "touchmove", (e) => {
            const currentX = e.touches[0].clientX;
            const currentY = e.touches[0].clientY;
            const deltaX = startX - currentX;
            const deltaY = startY - currentY;
            
            // Determine if the swipe is horizontal or vertical
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
              // The swipe is horizontal
                window.mfrScroll.stop();
            } else {
              // The swipe is vertical
            }
        } );
        this.$element.bind( "touchend", (e) => {
            window.mfrScroll.start();
        } );
    }
}